import { 
  getStructureType, getStructureTypeAlt, getStructureTypeAlt2,
  getTopLevelExpressionInfo, getTopLevelManifestationInfo, getTopLevelTranscriptionInfo,
  getItemExpressionInfo, getItemManifestationInfo, getItemTranscriptionInfo,
  getDivAndBelowExpressionInfo, getDivAndBelowManifestationInfo, getDivAndBelowTranscriptionInfo, getArticleTranscriptionDoc
} from "./queries";
import { runQuery } from "../utils";

export const getInfo: any = async (resourceid: string) => {
  let tokenRange: any;
  if (resourceid?.split("@")[1]){
    tokenRange = {start: parseInt(resourceid.split("@")[1].split("-")[0]), end: parseInt(resourceid.split("@")[1].split("-")[1])}
  }
  resourceid = resourceid?.split("@")[0]

  const structureTypePromise = runQuery(getStructureTypeAlt2(resourceid))
  
  const returnPromise = structureTypePromise.then((t) => {
    const bindings = t?.data?.results?.bindings[0]
    const type = bindings?.type?.value
    const structureType = bindings?.structureType?.value
    const resourceTitle = bindings?.resourceTitle?.value
    const level = bindings?.level?.value
    
  
    let returnObject: any = {}
   
  
    if (resourceid === "http://scta.info/resource/person"){
      returnObject = {displayType: "personList", resourceid: resourceid, structureType: "", topLevel: "", type: "", resourceTitle: ""}
    }
    else if (resourceid === "http://scta.info/resource/codex"){
      returnObject = {displayType: "codexList", resourceid: resourceid, structureType: "", topLevel: "", type: "", resourceTitle: ""}
    }
    else if (resourceid === "http://scta.info/resource/expressionType"){
      returnObject = {displayType: "expressionTypeList", resourceid: resourceid, structureType: "", topLevel: "", type: "", resourceTitle: ""}
    }
    else if (type === "http://scta.info/resource/expressionType"){
      returnObject = {displayType: "expressionType", resourceid: resourceid, structureType: "", topLevel: "", type: "", resourceTitle: ""}
    }
    else if (type === "http://scta.info/resource/person"){
      returnObject = {displayType: "person", resourceid: resourceid, structureType: "", topLevel: "", type: type, resourceTitle: resourceTitle}
    }
    // else if (type === "http://scta.info/resource/article"){
    //   const structureTypePromise = runQuery(getArticleTranscriptionDoc(resourceid))
    //   structureTypePromise.then((t) => {
    //     this.setState(
    //       {displayType: "article",
    //       articleDoc: t.data.results.bindings[0] ? t.data.results.bindings[0].doc.value : "", // conditional checks in case the query comes up empty; if empty it sets transcription id to ""
    //       articleType: t.data.results.bindings[0] ? t.data.results.bindings[0].articleType.value : "", // conditional checks in case the query comes up empty; if empty it sets transcription id to ""
    //       resourceid: resourceid,
    //       structureType: "", topLevel: "",
    //       type: type,
    //       resourceTitle: resourceTitle}
    //     )
    //   })

    // }
    else if (type === "http://scta.info/resource/codex"){
      returnObject = {displayType: "codex", resourceid: resourceid, structureType: "", topLevel: "", type: type, resourceTitle: resourceTitle}
    }
    else if (type === "http://scta.info/resource/surface"){
      returnObject = {displayType: "surface", resourceid: resourceid, structureType: "", topLevel: "", type: type, resourceTitle: resourceTitle}
    }
    else if (type === "http://iiif.io/api/presentation/2#Manifest"){
      returnObject = {displayType: "manifest", resourceid: resourceid, structureType: "", topLevel: "", type: type, resourceTitle: resourceTitle}
    }
    else if (type === "http://iiif.io/api/presentation/2#Canvas"){
      returnObject = {displayType: "canvas", resourceid: resourceid, structureType: "", topLevel: "", type: type, resourceTitle: resourceTitle}
    }
    else if (type === "http://scta.info/resource/workGroup"){
      returnObject = {displayType: "workGroup", resourceid: resourceid, structureType: structureType, type: type, resourceTitle: resourceTitle}
    }
    else if (type == "http://scta.info/resource/article"){
      returnObject = runQuery(getArticleTranscriptionDoc(resourceid)).then((t) => {
          return  {
            displayType: "article",
            articleDoc: t.data.results.bindings[0] ? t.data.results.bindings[0].doc.value : "", // conditional checks in case the query comes up empty; if empty it sets transcription id to ""
            articleType: t.data.results.bindings[0] ? t.data.results.bindings[0].articleType.value : "", // conditional checks in case the query comes up empty; if empty it sets transcription id to ""
            resourceid: resourceid,
            structureType: "", topLevel: "",
            type: type,
            resourceTitle: resourceTitle}
          })
    }
    else if (structureType === "http://scta.info/resource/structureCollection" && level === "1"){
      
      let query: string = ""
      if (type === "http://scta.info/resource/expression"){
        query = getTopLevelExpressionInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/manifestation"){
        query = getTopLevelManifestationInfo(resourceid)
      }
      else if (type === "http://scta/resource/transcription"){
        query = getTopLevelTranscriptionInfo(resourceid)
      }
      returnObject = runQuery(query).then((d) => {
        return {
          resourceid: resourceid,
          focusInfo: {
            expressionid: d.data.results.bindings[0].cexpression.value,
            manifestationid: d.data.results.bindings[0].cmanifestation.value,
            transcriptionid: d.data.results.bindings[0].ctranscription.value,
            structureType: "collection",
            level: level,
            mtFocus: d.data.results.bindings[0].ctranscription.value.split(d.data.results.bindings[0].cexpression.value)[1],
            resourceTitle: resourceTitle
          },
          topLevelInfo:{
            expressionid: d.data.results.bindings[0].cexpression.value,
            manifestationid: d.data.results.bindings[0].cexpression.value,
            transcriptionid: d.data.results.bindings[0].cexpression.value,
            author: d.data.results.bindings[0].author.value, 
            authorTitle: d.data.results.bindings[0].authorTitle.value
          }
        }
      })
    }
    else if (structureType === "http://scta.info/resource/structureCollection" && level !== "1"){
      let query: string = ""
      if (type === "http://scta.info/resource/expression"){
        query = getItemExpressionInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/manifestation"){
        query = getItemManifestationInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/transcription"){
        query = getItemTranscriptionInfo(resourceid)
      }
      returnObject = runQuery(query).then((d) => {
        return {
            resourceid: resourceid,
            focusInfo: {
              expressionid: d.data.results.bindings[0].cexpression.value,
              manifestationid: d.data.results.bindings[0].cmanifestation.value,
              transcriptionid: d.data.results.bindings[0].ctranscription.value,
              structureType: "collection",
              level: level,
              mtFocus: d.data.results.bindings[0].ctranscription.value.split(d.data.results.bindings[0].cexpression.value)[1],
              resourceTitle: resourceTitle
            },
            topLevelInfo:{
              expressionid: d.data.results.bindings[0].eTopLevel.value,
              manifestationid: d.data.results.bindings[0].mTopLevel.value,
              transcriptionid: d.data.results.bindings[0].tTopLevel.value,
              author: d.data.results.bindings[0].author?.value, 
              authorTitle: d.data.results.bindings[0].authorTitle?.value
            }
          }
        })
      }
    else if (structureType === "http://scta.info/resource/structureItem"){
      let query: string = ""
      if (type === "http://scta.info/resource/expression"){
        query = getItemExpressionInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/manifestation"){
        query = getItemManifestationInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/transcription"){
        query = getItemTranscriptionInfo(resourceid)
      }
      returnObject = runQuery(query).then((d) => {
        return {
            resourceid: resourceid,
            focusInfo: {
              expressionid: d.data.results.bindings[0].cexpression.value,
              manifestationid: d.data.results.bindings[0].cmanifestation.value,
              transcriptionid: d.data.results.bindings[0].ctranscription.value,
              structureType: "item",
              level: level,
              mtFocus: d.data.results.bindings[0].ctranscription.value.split(d.data.results.bindings[0].cexpression.value)[1],
              docSource: d.data.results.bindings[0].docSource?.value,
              resourceTitle: resourceTitle
            },
            itemInfo: {
              expressionid: d.data.results.bindings[0].cexpression.value,
              manifestationid: d.data.results.bindings[0].cmanifestation.value,
              transcriptionid: d.data.results.bindings[0].ctranscription.value,
            },
            topLevelInfo:{
              expressionid: d.data.results.bindings[0].eTopLevel.value,
              manifestationid: d.data.results.bindings[0].mTopLevel.value,
              transcriptionid: d.data.results.bindings[0].tTopLevel.value,
              author: d.data.results.bindings[0].author?.value, 
              authorTitle: d.data.results.bindings[0].authorTitle?.value
            }
          }
        })
      }
      
    else if (structureType === "http://scta.info/resource/structureElement" || structureType === "http://scta.info/resource/structureBlock" || structureType === "http://scta.info/resource/structureDivision" ){
      //const structureTypePromise = runQuery(getItemTranscriptionFromBlockDiv(resourceid))
      let query: string = ""
      if (type === "http://scta.info/resource/expression"){
        query = getDivAndBelowExpressionInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/manifestation"){
        query = getDivAndBelowManifestationInfo(resourceid)
      }
      else if (type === "http://scta.info/resource/transcription"){
        query = getDivAndBelowTranscriptionInfo(resourceid)
      }


      let structureTypeShortId = ""
      if (structureType === "http://scta.info/resource/structureDivision"){
        structureTypeShortId = "division"
      }
      else if (structureType === "http://scta.info/resource/structureElement"){
        structureTypeShortId = "element"
      }
      else if (structureType === "http://scta.info/resource/structureBlock"){
        structureTypeShortId = "block"
      }

      returnObject = runQuery(query).then((d) => {
        const info: any = {
          resourceid: resourceid + (tokenRange ? "@" + tokenRange.start + "-" + tokenRange.end : ""),
          focusInfo: {
            expressionid: d.data.results.bindings[0].cexpression.value,
            manifestationid: d.data.results.bindings[0].cmanifestation.value,
            transcriptionid: d.data.results.bindings[0].ctranscription.value,
            structureType: structureTypeShortId,
            level: level,
            mtFocus: d.data.results.bindings[0].ctranscription.value.split(d.data.results.bindings[0].cexpression.value)[1],
            docSource: d.data.results.bindings[0].docSource?.value,
            resourceTitle: resourceTitle
          },
          itemInfo: {
            expressionid: d.data.results.bindings[0].eItemParent.value,
            manifestationid: d.data.results.bindings[0].mItemParent.value,
            transcriptionid: d.data.results.bindings[0].tItemParent.value
          },
          topLevelInfo:{
            expressionid: d.data.results.bindings[0].eTopLevel.value,
            manifestationid: d.data.results.bindings[0].mTopLevel.value,
            transcriptionid: d.data.results.bindings[0].tTopLevel.value,
            author: d.data.results.bindings[0].author?.value,
            authorTitle: d.data.results.bindings[0].authorTitle?.value
          }
        }
        if (tokenRange){
          info.focusInfo["wordRange"] = tokenRange
        }
        return info
      })
    }
    else{
      returnObject = {displayType: "notFound"}
    }
    return returnObject
  })
  return returnPromise
}